import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { type ICalendarEvent } from '@principle-theorem/principle-core/interfaces';
import { toTimestamp, type WithRef } from '@principle-theorem/shared';

export interface IEditCalendarEventDialogData {
  calendarEvent: WithRef<ICalendarEvent>;
}

@Component({
  selector: 'pr-edit-calendar-event',
  templateUrl: './edit-calendar-event.component.html',
  styleUrls: ['./edit-calendar-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditCalendarEventComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IEditCalendarEventDialogData,
    private _dialogRef: MatDialogRef<
      EditCalendarEventComponent,
      WithRef<ICalendarEvent>
    >
  ) {}

  save(newEvent: ICalendarEvent): void {
    const storedEvent = this.data.calendarEvent;

    storedEvent.eventHistory.push({
      event: storedEvent.event,
      createdAt: toTimestamp(),
    });

    const { eventHistory } = newEvent;
    this._dialogRef.close({
      ...storedEvent,
      ...newEvent,
      eventHistory,
    });
  }
}
